import * as _ from "lodash";
import * as $ from "jquery";
import * as moment from "moment-timezone";
import {UserCollection} from "../../../collections/Users";
import {BaseDetailAccountView, BaseDetailAccountViewOptions} from "../_BaseAccountViews";
import {StatusNotificationCollection} from "../../../collections/StatusNotifications";
import {DashboardNotificationCollection} from "../../../collections/DashboardNotifications";
import {BaseList, TableProperties} from "../../_BaseList";
import {AddUserModal} from "./TeamModals";
import {GenericDeleteModal} from "../../modals/GenericDeleteModal";
import {Intercom} from "../../../common/intercom";
import * as Backbone from "backbone";
import {DashboardNotificationsView, InstallNotificationsView} from "./NotificationsView";
import {PermissionCollection} from "../../../collections/Permissions";
import {InstallCollection} from "../../../collections/Installs";
import {DashboardCollection} from "../../../collections/Dashboards";
import {
    BasePermissionSectionView,
    DashboardPermissionPreview,
    DashboardPermissionSectionView,
    InstallationPermissionPreview,
    InstallPermissionSectionView,
    UserGroupPermissionPreview,
    UserGroupPermissionSectionView,
    ReportPermissionPreview,
    ReportPermissionSectionView
} from "./PermissionView";
import {DataForwardsCollection} from "../../../apps/dataforwards/collections/DataForwards";

export interface TeamDetailViewOptions extends BaseDetailAccountViewOptions {
    currentUserGroup: Backbone.Model;
    userGroupPermissionCollection: PermissionCollection;
}

export abstract class BaseTeamDetailView extends BaseDetailAccountView {
    options: TeamDetailViewOptions;

    constructor(options: TeamDetailViewOptions) {
        super(options);
    }

    getBreadcrumbDetails(pathMap) {
        return {
            dropDownOptions: {},
            searchByX: '',
            currentPath: ''
        }
    }
}

export class TeamSettingsView extends BaseTeamDetailView {

    private settingsTemplate = _.template(require('templates/account/team/teamSettingsDetails.html'));

    constructor(options: TeamDetailViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'submit .account-modify-team-settings-form': 'handleTeamSettingsSubmitButton'
            }
        }));
    }

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/teams/' +
            this.options.currentUserGroup.get('id') + '/settings';
        this.$el.html(this.template({
            panelTitle: {text: 'General Settings', url: this.options.isOverview ? url : null},
            panelClass: 'settings',
            panelWidth: '',
            addButton: null,
            search: null,
            collectionLoaded: this.collectionLoaded,
            footer: null
        }));
        this.delegateEvents();
        return this;
    }

    show() {
        this.collectionLoaded = true;
        this.render();

        var userIsOrgAdmin   = this.options.currentUser.isSensewareAdmin();
        this.options.userGroupCollection.each((group) => {
            if (_.has(this.options.currentUser.get('usergroups'), String(group.get('id')))
                && group.get('is_admin')) userIsOrgAdmin = true;
        }, this);
        this.$('.panel-body > .row').append(this.settingsTemplate({
            teamName: this.options.currentUserGroup.get('name'),
            canEdit: userIsOrgAdmin
        }));
    }

    handleTeamSettingsSubmitButton(e) {
        e.preventDefault();
        var errorsSelector = this.$('.account-modify-team-settings-errors');
        errorsSelector.addClass('hidden');
        var errors = [];

        var name = (<string> this.$('.account-modify-team-settings-name').val());
        if(!name.length) errors.push('Team Name may not be empty');

        if (this.options.userGroupCollection.find((m) => {
                return m.get('name').toLowerCase() == name.toLowerCase()
                    && m.get('id') !== this.options.currentUserGroup.get('id')
            })) {
            errors.push('A team with this name already exists');
        }

        if(errors.length){
            errorsSelector.find('ul').html(
                errors.map((l) => {
                    return '<li>' + l + '</li>'
                }).join('')
            );
            errorsSelector.removeClass('hidden');
            return;
        }

        this.collectionLoaded = false;
        this.render();
        $.ajax({
            type: "PUT",
            url: this.options.userGroupCollection.url() + '/' + this.options.currentUserGroup.get('id'),
            data:  JSON.stringify({
                name: name
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: () => {
                this.reloadUrl();

                Intercom.trackEvent('changed-team-settings', {
                    org_id: this.options.currentOrganizationId,
                    team_id: this.options.currentUserGroup.get('id')
                });
            }
        });
    }
}

export class TeamUsersView extends BaseTeamDetailView {

    constructor(options: TeamDetailViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-user-team-button': 'handleCreateUserButtonClick',
                'click .delete-from-list': 'handleDeleteUserGroupUser',
                'click .account-modify-team-resent-invite': 'handleResentClicked'
            }
        }));
    }

    render() {
        var url = '/#/account/' + this.options.currentOrganizationId + '/teams/' +
            this.options.currentUserGroup.get('id') + '/users';
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        var canAddUser = this.options.permissionCollection.canAddUserToUserGroup(this.options.currentUserGroup.get('id'));
        this.$el.html(this.template({
            panelTitle: {text: 'Users in this Team', url: this.options.isOverview ? url : null},
            panelClass: 'users',
            panelWidth: '',
            addButton: {canAdd: canAddUser, label: "Add User", 'class': "add-user-team-button"},
            search: !this.options.isOverview,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
        this.delegateEvents();
        return this;
    }

    show() {
        this.collectionLoaded = true;
        this.render();
        this.showTable();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
    }

    showTable() {
        var table = new BaseList(this.options);
        var tableProperties: TableProperties = {
            tableEmptyText: 'There are no Users',
            canDeletePermissionFunction: () => {
                return this.options.permissionCollection.canAddUserToUserGroup(this.options.currentUserGroup.get('id'))
            },
            canDeletePermissionFunctionAttribute: 'id',
            columnProperties: {
                'Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Email': {
                    attribute: 'email',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Phone Number': {
                    attribute: 'phone_number',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Member Since': {
                    attribute: 'usergroups',
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("usergroups")[userGroupId] ? mod.get("usergroups")[userGroupId]["invitation_accepted_date"] : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10"><%- moment(inviteDate).format("L") %></div>' +
                            ' <% } else { %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 account-modify-team-member-since">' +
                            ' <div class="account-modify-team-invitation-pending">' +
                            ' Invitation Pending <br>' +
                            ' <a class="clickable account-modify-team-resent-invite team-footer table-link" data-user-id="<%- mod.get("id") %>" data-usergroup-id="<%- userGroupId %>">' +
                            ' Resend Invitation' +
                            ' </a>' +
                            ' <span class="text-success account-modify-team-invitation-sent hidden">Sent.</span>' +
                            ' </div>' +
                            ' <div class="modal-form-spinner hidden">' +
                            ' <div class="spinner-rect">' +
                            ' <div class="rect1"></div>' +
                            ' <div class="rect2"></div>' +
                            ' <div class="rect3"></div>' +
                            ' <div class="rect4"></div>' +
                            ' <div class="rect5"></div>' +
                            ' </div>' +
                            ' </div>' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            userGroupId: this.options.currentUserGroup.get('id'),
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
            }
        };

        if (this.options.isOverview) {
            tableProperties['limitedRows'] = {
                count: 3,
                sortBy: 'is_admin',
                reverseSort: true,
                collectionProperties: {
                    organizationId: this.options.currentOrganizationId
                }
            };
        }

        var users = this.options.userCollection.filter((user) => {
            return _.has(user.get('usergroups'), String(this.options.currentUserGroup.get('id')))
        });
        var userGroupUserCollection = new UserCollection(users, {organizationId: this.options.currentOrganizationId});

        this.$('.panel-body > .row').empty().append(
            table.renderCollectionList(userGroupUserCollection, tableProperties).$el
        );
    }

    handleCreateUserButtonClick() {
        var view = new AddUserModal(_.extend({}, this.options, {
            currentUserGroupId: this.options.currentUserGroup.get('id')
        }));
        $('.modals').append(view.render().el);
        view.show();
    }

    handleDeleteUserGroupUser(e: JQuery.UIEventBase) {
        e.stopPropagation();
        var id = Number($(e.currentTarget).attr('data-model-id'));
        var user = this.options.userCollection.findWhere({id: id});

        var modal = new GenericDeleteModal({
            type: 'User',
            name: user.get('name'),
            func: () => {
                return $.ajax({
                    type: "DELETE",
                    url: this.options.userGroupCollection.url() + '/' + this.options.currentUserGroup.get('id') + '/users/' + id,
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                    complete: () => {
                        Intercom.trackEvent('deleted-user-from-team', {
                            org_id: this.options.currentOrganizationId,
                            team_id: this.options.currentUserGroup.get('id'),
                            user_id: id
                        });

                        this.reloadUrl();
                    }
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    handleResentClicked(e) {
        var target = $(<string> e.currentTarget);
        var parentTd = target.parents('.account-modify-team-member-since');

        var userId = Number(target.attr('data-user-id'));
        var userGroupId = Number(target.attr('data-usergroup-id'));
        var user = this.options.userCollection.findWhere({id: userId});

        parentTd.find('.modal-form-spinner').removeClass('hidden');
        parentTd.find('.account-modify-team-invitation-pending').addClass('hidden');

        $.ajax({
            type: "POST",
            url: this.options.userCollection.url(),
            data: JSON.stringify({
                name: user.get('name'),
                company_name: user.get('company_name'),
                company_role: user.get('company_role'),
                email: user.get('email'),
                phone_number: user.get('phone_number'),
                usergroup: userGroupId
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: () => {
                parentTd.find('.modal-form-spinner').addClass('hidden');
                parentTd.find('.account-modify-team-invitation-pending').removeClass('hidden');
                parentTd.find('.account-modify-team-invitation-sent').removeClass('hidden');
            }
        });
    }
}

export class TeamPermissionView extends BaseTeamDetailView {
    options: TeamDetailViewOptions;

    private dataForwardsCollection: DataForwardsCollection = new DataForwardsCollection([], {});
    private subDetail: string = null;

    constructor(options: TeamDetailViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .save-permissions': 'handlePermissionSaveClick',
            }
        }));
    }

    render() {
        if (this.options.isOverview) {
            var url = '/#/account/' + this.options.currentOrganizationId + '/teams/' +
                this.options.currentUserGroup.get('id') + '/permissions';
            var footer = {text: 'View All', url: url};

            this.$el.html(this.template({
                panelTitle: {text: 'Permissions', url: url},
                panelClass: 'permissions',
                panelWidth: '',
                addButton: null,
                search: !this.options.isOverview,
                collectionLoaded: this.collectionLoaded,
                footer: footer
            }));
            this.delegateEvents();
        }

        // If viewing Admin Team, add notice to let Users know permissions cannot be edited
        if (this.options.currentUserGroup.get('is_admin')) {
            this.addDescription("Administrators team must have all permissions and cannot be edited.", this.options.isOverview);
        }

        return this;
    }

    show(subDetail) {
        this.subDetail = subDetail;

        var deferreds = [];
        this.options.appCollection.each((app) => {
            if (app.get('organization_id') !== this.options.currentOrganizationId) return;

            deferreds.push(this.options.appRegistry.getInstance(app.get('type')));
        });

        var when = $.when.apply($, deferreds);
        if (this.options.isOverview) {
            return when.then((...appInstances) => {

                // Then load all permission previews
                return $.when.apply($, _.map(appInstances, (a) => {
                    return a.getPermissionPreview(this.options)
                }));
            }).then((...previewInstances) => {
                // Render all previews
                this.collectionLoaded = true;
                this.render();
                var previews = [
                    DashboardPermissionPreview,
                    UserGroupPermissionPreview,
                    InstallationPermissionPreview,
                    ReportPermissionPreview
                ];

                var instances = _.map(previews , (klass) => {
                    return new klass(_.extend(this.options, {
                        dataForwardsCollection: this.dataForwardsCollection
                    }));
                });

                _.each(instances.concat(previewInstances), (i) => {
                    this.renderPreview(i);
                })
            })
        } else {
            return when.then((...appInstances) => {
                // Then load all permission previews
                return $.when.apply($, _.map(appInstances, (a) => {
                    return a.getPermissionSectionView(this.options)
                }));
            }).then((...sectionInstances) => {
                var instances = [
                    new DashboardPermissionSectionView(_.extend({}, this.options)),
                    new InstallPermissionSectionView(_.extend({}, this.options)),
                    new UserGroupPermissionSectionView(_.extend({}, this.options)),
                    new ReportPermissionSectionView(_.extend({}, this.options))
                ];

                _.each(instances.concat(sectionInstances), (i) => {
                    i.setHidden(subDetail && (i.getUrlAddon() !== subDetail));

                    this.subViews.push(i);
                    this.render();
                    this.$el.append(i.render().$el);
                    i.show();
                });

                this.delegateEvents();
            })
        }
    }

    protected renderPreview(viewInstance) {
        this.subViews.push(viewInstance);
        this.$('.panel-body > .row').append(viewInstance.render().$el);
        viewInstance.show();
    }

    addDescription(text: string, isOverview: boolean){
            const paragraph = document.createElement("p");
            paragraph.setAttribute( "class", "description" );
            const node = document.createTextNode(text);
            paragraph.appendChild(node);

            if(isOverview){
                $('.permissions .panel-heading .description').remove();
                $('.permissions .panel-heading').append(paragraph);
            }else{
                $('.title.account-title .description').remove();
                $('.title.account-title').append(paragraph);
            }
    }

    getBreadcrumbDetails(pathMap) {
        var dropDownOptions = {}, searchByX = 'Permission Detail', currentPath = '';
        var teamId = this.options.currentUserGroup.get('id');
        var routeString = '/#/account/' + this.options.currentOrganizationId + '/teams/' + teamId + '/permissions';

        _.each(this.subViews, (v: BasePermissionSectionView) => {
            dropDownOptions[v.getTitle()] = routeString + '/' + v.getUrlAddon();

            if (this.subDetail === v.getUrlAddon()) {
                pathMap[v.getTitle()] = routeString + '/' + v.getUrlAddon();
                currentPath = v.getTitle();
            }
        });
        return {
            dropDownOptions: dropDownOptions,
            searchByX: searchByX,
            currentPath: currentPath
        }
    }

    handlePermissionSaveClick(e: JQuery.UIEventBase) {
        var groupId = this.options.currentUserGroup.get('id');
        var permissions = _.flatMap(_.map(this.subViews, (v: BasePermissionSectionView) => {
            return v.getPermissions();
        }));

        $.ajax({
            type: "PUT",
            url: this.options.permissionCollection.url() + '/' + groupId,
            data: JSON.stringify(permissions),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            complete: () => {
                this.reloadUrl();

                Intercom.trackEvent('changed-team-permissions', {
                    org_id: this.options.currentOrganizationId,
                    team_id: groupId
                });
            }
        });
    }
}

export class TeamNotificationView extends BaseTeamDetailView {

    private dashboardNotificationCollection: DashboardNotificationCollection = null;
    private statusNotificationCollection: StatusNotificationCollection = null;
    private notificationType: string = null;
    private notificationEntityId: number = null;

    show(notificationType, notificationEntityId) {
        this.notificationType = notificationType;
        this.notificationEntityId = Number(notificationEntityId);

        var deferreds = [];

        if (this.options.isOverview || !notificationType || notificationType === 'install') {
            this.statusNotificationCollection = new StatusNotificationCollection([], {
                userGroupId: this.options.currentUserGroup.get('id')
            });
            deferreds.push(this.statusNotificationCollection.getCollectionFetchPromise());
        }
        if (this.options.isOverview || !notificationType || notificationType === 'dashboard') {
            this.dashboardNotificationCollection = new DashboardNotificationCollection([], {
                userGroupId: this.options.currentUserGroup.get('id')
            });
            deferreds.push(this.dashboardNotificationCollection.getCollectionFetchPromise());
        }

        return $.when.apply($, deferreds).done(() => {
            this.collectionLoaded = true;
            this.render();

            if (this.options.isOverview) {
                // If it's the overview, render overview tables
                this.showOverviewTables();
            } else if (!this.options.isOverview && !notificationEntityId) {
                if (this.notificationType) {
                    this.showListTables(this.notificationType);
                } else {
                    this.showListTables('dashboard');
                    this.showListTables('install');
                }
            } else {
                this.renderNotificationViews(notificationType);
            }
        });
    }

    render() {
        this.$el.empty();
        if (!this.collectionLoaded) {
            this.appendPanel('', '');

        } else if (this.options.isOverview) {
            this.appendPanel('Notifications', 'notifications');

        } else if ((!this.options.isOverview || this.notificationType) && !this.notificationEntityId) {
            if (!this.notificationType || this.notificationType === 'dashboard') {
                this.appendPanel(
                    'Dashboard Notifications',
                    'dashboard-notifications',
                    'dashboard',
                    'Get notified via email or text message whenever a sensor channel crosses a threshold. For channels to be available in this form, they must be added to a dashboard.'
                );
            }
            if (!this.notificationType || this.notificationType === 'install') {
                this.appendPanel(
                    'Installation Notifications',
                    'install-notifications',
                    'install',
                    'Get notified via email or text about the health of your Installation. This includes notifications about modules losing connectivity or a module battery having to be replaced.',
                );
            }
        }
        return this;
    }

    private appendPanel(title: string, klass: string, urlAddon?: string, subTitle?: string) {
        var url = '/#/account/' + this.options.currentOrganizationId + '/teams/' +
            this.options.currentUserGroup.get('id') + '/notifications' +
            (urlAddon ? '/' + urlAddon : '');
        var footer = this.options.isOverview ? {text: 'View All', url: url} : null;

        this.$el.append(this.template({
            panelTitle: {
                text: title,
                url: (urlAddon !== this.notificationType || !urlAddon) ? url : null,
                subTitle: subTitle
            },
            panelClass: klass,
            panelWidth: '',
            addButton: null,
            search: !this.options.isOverview && this.collectionLoaded,
            collectionLoaded: this.collectionLoaded,
            footer: footer
        }));
    }

    private getRelevantDashboards(mustHaveNotifications: boolean) {
        var viewableDashboards = this.options.userGroupPermissionCollection.getViewableDashboardIds();
        return new DashboardCollection(this.options.dashboardCollection.filter((dashboard) => {
            var dashboardId = dashboard.get("id");
            var hasNotif = Boolean(this.dashboardNotificationCollection.find((c) => {
                return c.get('dashboard_id') === dashboardId && (
                        c.get("enable_email_notifications") || c.get("enable_sms_notifications")
                )
            }));
            return _.includes(viewableDashboards, dashboardId) && (hasNotif || !mustHaveNotifications);
        }));
    }

    private getRelevantInstallations(mustHaveNotifications: boolean) {
        var viewableInstalls = this.options.userGroupPermissionCollection.getViewableInstallIds();
        return new InstallCollection(this.options.installCollection.filter((install) => {
            var installId = install.get("id");
            var hasNotif = Boolean(this.statusNotificationCollection.find((c) => {
                return c.get('install_id') === installId && (
                        c.get("enable_email_notifications") || c.get("enable_sms_notifications")
                )
            }));
            return _.includes(viewableInstalls, installId) && (hasNotif || !mustHaveNotifications);
        }));
    }

    getBreadcrumbDetails(pathMap) {
        var dropDownOptions = {}, searchByX = '', currentPath = '';
        var teamId = this.options.currentUserGroup.get('id');
        var routeString = '/#/account/' + this.options.currentOrganizationId + '/teams/' + teamId + '/notifications';

        if (this.notificationEntityId) {
            // url ending with notifications/<type>/<entity>
            if (this.notificationType === 'dashboard') {
                pathMap['Dashboard Notifications'] = routeString + '/dashboard';
                searchByX = 'Dashboards';

                var route = routeString + '/dashboard';
                this.getRelevantDashboards(false).each((d) => {
                    dropDownOptions[d.get('name')] = route + '/' + d.get('id');

                    if (d.get('id') === this.notificationEntityId) {
                        currentPath = d.get('name');
                    }
                })
            } else {
                pathMap['Installation Notifications'] = routeString + '/install';
                searchByX = 'Installations';

                var route = routeString + '/install';
                this.getRelevantInstallations(false).each((i) => {
                    dropDownOptions[i.getDisplayName()] = route + '/' + i.get('id');

                    if (i.get('id') === this.notificationEntityId) {
                        currentPath = i.getDisplayName();
                    }
                })
            }
        } else {
            searchByX = 'Notification Type';
            // url ending with notifications/<type>
            if (this.notificationType === 'dashboard') {
                currentPath = 'Dashboard Notifications';
            } else {
                currentPath = 'Installation Notifications';
            }

            dropDownOptions = {
                'Dashboard Notifications': routeString + '/dashboard',
                'Installation Notifications': routeString + '/install',
            }
        }
        return {
            dropDownOptions: dropDownOptions,
            searchByX: searchByX,
            currentPath: currentPath
        }
    }

    private showListTables(notificationType: string) {
        var table;
        var url = '#/account/' + this.options.currentOrganizationId + '/teams/' +
            this.options.currentUserGroup.get('id') + '/notifications/';
        if (notificationType === 'dashboard') {
            table = {
                columnName: 'Dashboard',
                tableEmptyText: 'This group has no Dashboard Notifications',
                rowUrl: url + 'dashboard/',
                notificationCollection: this.dashboardNotificationCollection,
                property: 'dashboard_id',
                collection: this.getRelevantDashboards(false),
                klass: 'dashboard-notifications'
            };
        } else if (notificationType === 'install') {
            table = {
                columnName: 'Installation',
                tableEmptyText: 'This group has no Installation Notifications',
                rowUrl: url + 'install/',
                notificationCollection: this.statusNotificationCollection,
                property: 'install_id',
                collection: this.getRelevantInstallations(false),
                klass: 'install-notifications'
            };
        }

        var baseList = new BaseList(this.options);
        var props = {
            tableEmptyText: table.tableEmptyText,
            rowUrl: table.rowUrl,
            columnProperties: {
                [table.columnName]: {
                    customColumn: {
                        templateFunction: _.template('' +
                            '<div class="col-md-5 col-sm-5 col-xs-5" data-table-cell="<%- mod.getDisplayName ? mod.getDisplayName() : mod.get("name") %>">' +
                            ' <%- mod.getDisplayName ? mod.getDisplayName() : mod.get("name") %>' +
                            ' </div>')
                    },
                    columnSizes: {'sm': '5', 'md': '5', 'xs': '5'}
                },
                'Email Notifications': {
                    customColumn: {
                        templateFunction: _.template(require('templates/account/team/notificationDetailsList.html')),
                        variables: {
                            notificationCollection: table.notificationCollection,
                            property: table.property,
                            matchProperty: 'enable_email_notifications'
                        },
                    },
                    centerColumn: true,
                    columnSizes: {'sm': '3', 'md': '3', 'xs': '3'}
                },
                'Text Notifications': {
                    customColumn: {
                        templateFunction: _.template(require('templates/account/team/notificationDetailsList.html')),
                        variables: {
                            notificationCollection: table.notificationCollection,
                            property: table.property,
                            matchProperty: 'enable_sms_notifications'
                        },
                    },
                    centerColumn: true,
                    columnSizes: {'sm': '3', 'md': '3', 'xs': '3'}
                },
            }
        };

        this.$('.' + table.klass + ' .panel-body > .row').append(
            baseList.renderCollectionList(table.collection, props).$el
        );
    }

    private showOverviewTables() {
        var tableWidth = this.options.isOverview ? 'col-md-6 col-sm-6 col-xs-12' : 'col-md-12 col-sm-12 col-xs-12';

        var url = '#/account/' + this.options.currentOrganizationId + '/teams/' +
            this.options.currentUserGroup.get('id') + '/notifications/';
        var tables = [{
            columnName: 'Dashboard',
            rowUrl: url + 'dashboard/',
            tableEmptyText: 'This group has no Dashboard Notifications',
            notificationCollection: this.dashboardNotificationCollection,
            property: 'dashboard_id',
            collection: this.getRelevantDashboards(true),
            footer: {
                url: url + 'dashboard',
                text: 'Set up Notifications'
            }
        }, {
            columnName: 'Installation',
            rowUrl: url + 'install/',
            tableEmptyText: 'This group has no Installation Notifications',
            notificationCollection: this.statusNotificationCollection,
            property: 'install_id',
            collection: this.getRelevantInstallations(true),
            footer: {
                url: url + 'install',
                text: 'Set up Notifications'
            }
        }];

        _.each(tables, (t) => {
            var baseList = new BaseList(this.options);
            var props = {
                tableEmptyText: t.tableEmptyText,
                rowUrl: t.rowUrl,
                columnProperties: {
                    [t.columnName]: {
                        customColumn: {
                            templateFunction: _.template(' <div class="col-md-6 col-sm-6 col-xs-12">' +
                                ' <%- mod.getDisplayName ? mod.getDisplayName() : mod.get("name") %>' +
                                ' </div>')
                        },
                        columnSizes: {'sm': '6', 'md': '6', 'xs': '12'}
                    },
                    'Enabled Notifications': {
                        customColumn: {
                            templateFunction: _.template(require('templates/account/team/notificationDetailsOverview.html')),
                            variables: {
                                notificationCollection: t.notificationCollection,
                                property: t.property
                            }
                        },
                        columnSizes: {'sm': '5', 'md': '5', 'xs': '12'}
                    }
                },
                limitedRows: {
                    count: 3,
                    sortBy: 'name',
                    reverseSort: true,
                    collectionProperties: {
                        organizationId: this.options.currentOrganizationId
                    }
                },
                name: t.columnName + ' Notifications',
                tableWidth: tableWidth,
                footer: t.footer
            };

            this.$('.notifications .panel-body > .row').append(
                baseList.renderCollectionList(t.collection, props).$el
            );
        });
    }

    private renderNotificationViews(notificationType) {
        var subview;
        switch (notificationType) {
            case 'dashboard':
                subview = new DashboardNotificationsView(_.extend({}, this.options, {
                    dashboardNotificationCollection: this.dashboardNotificationCollection,
                    dashboardId: this.notificationEntityId
                }));
                break;

            case 'install':
                subview = new InstallNotificationsView(_.extend({}, this.options, {
                    statusNotificationCollection: this.statusNotificationCollection,
                    installId: this.notificationEntityId
                }));
                break;
        }
        if (subview) {
            this.subViews.push(subview);
            this.$el.append(subview.render().$el);
            subview.show();
        }
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/account/team/TeamDetailViews.ts